import { defineStore } from "pinia"
import { ServiceService } from "@/store/services/service.service.js"
import { storeToRefs } from "pinia"

export const serviceStore = defineStore("service", {
  state: () => {
    return {
      service: "",
    }
  },
  getters: {
    getServices: (state) => state.service,
  },
  actions: {
    getServicesAction() {
      if (this.service != "") return this.service
      EventSys.$emit("service_loading")
      ServiceService.list().then(({ data }) => {
        EventSys.$emit("service_loaded")
        this.service = data
      })
    },
  },
})
